import PropTypes from 'prop-types'

const VerticalRule = ({ type }) => (
  <div className={`toast-vertical-rule ${type}`} />
)

export default VerticalRule

VerticalRule.propTypes = { type: PropTypes.string.isRequired }
